<!-- 
<nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent" style=" background-color: #fff !important; padding: 0 !important;">
  <div class="container-fluid">
    <div class="py-3 pl-0 pl-lg-4 logo-wrapper mr-0 mr-lg-4" >
      <img routerLink="/app/dashboard" style="cursor: pointer;" src="/assets/img/Logo2.svg" class="ml-3 ml-lg-0 mt-3 mt-lg-0" alt="Logo Image">
  </div>
  <h5 style="font-size: 20px; color: var(--theme-color1);" class="mt-3">{{getTitle()}}</h5>
    <button class="navbar-toggler" type="button" (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="isCollapsed">
      <div class="d-flex align-items-center justify-content-center nav-link-wrapper" style=" border-radius: 10px;">
        <div class="mr-3 cursor-pointer" routerLink="/app/notifications">
          <img  src="/assets/img/notification-icon.svg" alt="">
        </div>
        <div class="mr-2">
          <img style="height: 50px;" src="/assets/img/user-icon.png" alt="">
        </div>
        <div class="mr-3">
          <h6 style="margin-bottom: 0px !important;margin-top: 0px !important;" class="name">{{user?.name}}</h6>
          <small class="d-block" style="color: #9C9C9C;">Good Day</small>
        </div>
        <div class="mr-3">
          <div class="dropdown">

            <button class="btn menu-btn px-3 py-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" > <img src="/assets/img/Hamburger Menu.png" class="mr-2" alt=""> <span>Menu</span></button>
            <div class="dropdown-menu p-4" style="position: absolute !important;left: -150% !important;min-width: 16rem !important;" aria-labelledby="dropdownMenuButton">
              <a *ngFor="let item of menuItems" routerLink="{{item.path}}" class="dropdown-item d-flex align-items-center" style="cursor: pointer;" > <span><img src="{{item.icon}}" class="{{item.class}}"  alt=""></span> <span class="mx-4" style="color:rgba(1, 97, 177, 0.35);">|</span> <span class="text-dark">{{item.title}}</span></a>
              <a  (click)="logout()" class="dropdown-item d-flex align-items-center" style="cursor: pointer;" > <span><img src="/assets/img/logout-icon.svg" class="w"  alt=""></span> <span class="mx-4" style="color:rgba(1, 97, 177, 0.35);">|</span> <span class="text-dark">Logout</span></a>
            </div>
          </div>
        </div>
      </div>




    </div>
  </div>
</nav> -->

<nav
  class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
  style="background-color: #fff !important; padding: 0 !important"
>
  <div class="container-fluid">
    <div class="py-3 pl-0 pl-lg-4 logo-wrapper mr-0 mr-lg-4">
      <img
        [routerLink]="['/app/profile-page']"
        style="cursor: pointer"
        src="/assets/img/Logo2.svg"
        class="ml-3 ml-lg-0"
        alt="Logo Image"
      />
    </div>
    <h5
      style="font-size: 20px; color: var(--theme-color1)"
      class="mt-3 d-none d-lg-block"
    >
      {{ getTitle() }}
    </h5>
    <button
      class="btn menu-btn px-3 py-2 mobile-only"
      type="button"
      (click)="mobileSidebarToggle()"
    >
      <img src="/assets/img/Hamburger Menu.png" class="mr-2" alt="" />
      <span>Menu</span>
    </button>
    <!-- <button class="navbar-toggler" type="button" (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button> -->
    <div
      class="collapse navbar-collapse justify-content-end"
      id="collapseExample"
      [ngbCollapse]="isCollapsed"
    >
      <div
        class="d-flex align-items-center justify-content-center nav-link-wrapper"
        style="border-radius: 10px"
      >
        <div class="mr-3 cursor-pointer" routerLink="/app/notifications">
          <img src="/assets/img/notification-icon.svg" alt="" />
        </div>
        <div class="mr-2">
          <img style="height: 50px" src="/assets/img/user-icon.png" alt="" />
        </div>
        <div class="mr-3">
          <h6
            style="margin-bottom: 0px !important; margin-top: 0px !important"
            class="name"
          >
            {{ user?.name }}
          </h6>
          <small class="d-block" style="color: #9c9c9c">Good Day</small>
        </div>
        <div class="mr-3">
          <div class="dropdown">
            <button
              class="btn menu-btn px-3 py-2"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src="/assets/img/Hamburger Menu.png" class="mr-2" alt="" />
              <span>Menu</span>
            </button>
            <div
              class="dropdown-menu p-4"
              style="
                position: absolute !important;
                left: -150% !important;
                min-width: 16rem !important;
              "
              aria-labelledby="dropdownMenuButton"
            >
              <a
                *ngFor="let item of menuItems"
                [routerLink]="item.path"
                class="dropdown-item d-flex align-items-center"
                style="cursor: pointer"
              >
                <span
                  ><img src="{{ item.icon }}" class="{{ item.class }}" alt=""
                /></span>
                <span class="mx-4" style="color: rgba(1, 97, 177, 0.35)"
                  >|</span
                >
                <span class="text-dark">{{ item.title }}</span></a
              >
              <a
                (click)="logout()"
                class="dropdown-item d-flex align-items-center"
                style="cursor: pointer"
              >
                <span
                  ><img src="/assets/img/logout-icon.svg" class="w" alt=""
                /></span>
                <span class="mx-4" style="color: rgba(1, 97, 177, 0.35)"
                  >|</span
                >
                <span class="text-dark">Logout</span></a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link btn-magnify" href="javascript:void(0)">
            <i class="nc-icon nc-layout-11"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>

        <li class="nav-item btn-rotate" ngbDropdown placement="bottom-left">
          <a class="nav-link" ngbDropdownToggle id="navbarDropdownMenuLink" >
            <i class="nc-icon nc-bell-55"></i>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div ngbDropdownMenu aria-labelledby="navbarDropdownMenuLink" class="dropdown-menu dropdown-menu-right">
            <a ngbDropdownItem routerLink="/auth/login">Log out</a>
            <a ngbDropdownItem href="javascript:void(0)">Another action</a>
            <a ngbDropdownItem href="javascript:void(0)">Something else here</a>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link btn-rotate" href="javascript:void(0)">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li> 
      </ul> -->
    </div>
  </div>
</nav>
<div
  class="sidebar-overlay"
  *ngIf="mobileSidebarOpen"
  (click)="mobileSidebarToggle()"
></div>
<div class="mobile-sidebar-wrapper" [class.open]="mobileSidebarOpen">
  <app-mobile-sidebar
    *ngIf="mobileSidebarOpen"
    [userName]="user?.display_name"
    (close)="mobileSidebarToggle()"
  ></app-mobile-sidebar>
</div>
